"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizeLabelTypeName = exports.labelTypeToString = exports.stringToDataQualityType = exports.LabelType = void 0;
var Localize_1 = require("../../../../gen-src/Localize");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
var LabelType;
(function (LabelType) {
    LabelType[LabelType["WARNING"] = 0] = "WARNING";
    LabelType[LabelType["DEPRECATED"] = 1] = "DEPRECATED";
    LabelType[LabelType["STALE"] = 2] = "STALE";
    LabelType[LabelType["MAINTENANCE"] = 3] = "MAINTENANCE";
    LabelType[LabelType["SENSITIVE_DATA"] = 4] = "SENSITIVE_DATA";
    LabelType[LabelType["EXTRACT_REFRESH_FAILURE"] = 5] = "EXTRACT_REFRESH_FAILURE";
    LabelType[LabelType["FLOW_RUN_FAILURE"] = 6] = "FLOW_RUN_FAILURE";
    LabelType[LabelType["CERTIFIED"] = 7] = "CERTIFIED";
})(LabelType = exports.LabelType || (exports.LabelType = {}));
function stringToDataQualityType(type) {
    switch (type) {
        case LabelType[LabelType.WARNING]: return LabelType.WARNING;
        case LabelType[LabelType.DEPRECATED]: return LabelType.DEPRECATED;
        case LabelType[LabelType.STALE]: return LabelType.STALE;
        case LabelType[LabelType.MAINTENANCE]: return LabelType.MAINTENANCE;
        case LabelType[LabelType.SENSITIVE_DATA]: return LabelType.SENSITIVE_DATA;
        case LabelType[LabelType.EXTRACT_REFRESH_FAILURE]: return LabelType.EXTRACT_REFRESH_FAILURE;
        case LabelType[LabelType.FLOW_RUN_FAILURE]: return LabelType.FLOW_RUN_FAILURE;
        case LabelType[LabelType.CERTIFIED]: return LabelType.CERTIFIED;
        default: return LabelType.WARNING;
    }
}
exports.stringToDataQualityType = stringToDataQualityType;
function labelTypeToString(type) {
    return LabelType[type];
}
exports.labelTypeToString = labelTypeToString;
function localizeLabelTypeName(type) {
    switch (type) {
        case LabelType.WARNING:
            return Localize_1.Messages.DataQualityTypeWarning();
        case LabelType.DEPRECATED:
            return Localize_1.Messages.DataQualityTypeDeprecated();
        case LabelType.STALE:
            return Localize_1.Messages.DataQualityTypeStale();
        case LabelType.MAINTENANCE:
            return Localize_1.Messages.DataQualityTypeMaintenance();
        case LabelType.SENSITIVE_DATA:
            return Localize_1.Messages.DataQualityTypeSensitiveData();
        case LabelType.EXTRACT_REFRESH_FAILURE:
            return Localize_1.Messages.DataQualityTypeExtractRefreshFailure();
        case LabelType.FLOW_RUN_FAILURE:
            return Localize_1.Messages.DataQualityTypeFlowRunFailure();
        case LabelType.CERTIFIED:
            return Localize_1.Messages.DataQualityTypeCertified();
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(type);
            return '';
    }
}
exports.localizeLabelTypeName = localizeLabelTypeName;
//# sourceMappingURL=LabelType.js.map